/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiply by 3.6. It comes directly from unit arithmetic: there are 3,600 seconds in an hour and 1,000 meters in a kilometer, so m/s × 3,600 ÷ 1,000 simplifies to m/s × 3.6. It's exact, not an approximation, so you can rely on it without a calculator.`)
};

const es_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplica por 3.6. Viene directamente de la aritmética unitaria: hay 3,600 segundos en una hora y 1,000 metros en un kilómetro, así que m/s × 3,600 ÷ 1,000 se simplifica a m/s × 3.6. Es exacto, no una aproximación, así que puedes confiar en él sin calculadora.`)
};

const de_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplizieren Sie mit 3.6. Das ergibt sich direkt aus der Einheitenarithmetik: Eine Stunde hat 3,600 Sekunden und ein Kilometer 1,000 Meter, sodass sich m/s × 3,600 ÷ 1,000 zu m/s × 3.6 vereinfacht. Das ist exakt, keine Näherung, Sie können sich also ohne Taschenrechner darauf verlassen.`)
};

const nl_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermenigvuldig met 3.6. Het komt rechtstreeks van eenheid rekenkunde: er zijn 3.600 seconden in een uur en 1.000 meter in een kilometer, dus m/s × 3.600 ÷ 1.000 vereenvoudigt naar m/s × 3.6. Het is exact, geen benadering, dus u kunt er zonder rekenmachine op vertrouwen.`)
};

const fr_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multipliez par 3,6. Il vient directement de l'arithmétique des unités : il y a 3 600 secondes dans une heure et 1 000 mètres dans un kilomètre, donc m/s × 3 600 ÷ 1 000 se simplifie en m/s × 3,6. C'est exact, pas une approximation, donc vous pouvez vous y fier sans calculatrice.`)
};

const it_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moltiplicare per 3,6. Proviene direttamente dall'aritmetica delle unità: ci sono 3.600 secondi in un'ora e 1.000 metri in un chilometro, quindi m/s × 3.600 ÷ 1.000 si semplifica a m/s × 3,6. È esatto, non un'approssimazione, quindi puoi fare affidamento su di esso senza una calcolatrice.`)
};

const pt_br2_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplique por 3.6. Vem diretamente da aritmética unitária: há 3.600 segundos em uma hora e 1.000 metros em um quilômetro, então m/s × 3.600 ÷ 1.000 simplifica para m/s × 3.6. É exato, não uma aproximação, então você pode contar com isso sem calculadora.`)
};

const pt_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplicar por 3,6. Vem directamente da aritmética de unidades: existem 3600 segundos numa hora e 1000 metros num quilómetro, portanto m/s × 3600 ÷ 1000 simplifica para m/s × 3,6. É exacto, não uma aproximação, portanto pode contar com ele sem uma calculadora.`)
};

const ja_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.6で乗じます。ユニット演算から直接来ています。1時間に3,600秒あり、1キロメートルに1,000メートルあります。m/s × 3,600 ÷ 1,000 は m/s × 3.6 に簡略化されます。それは近似ではなく正確であるため、計算機なしで頼ることができます。`)
};

const zh_uc_speed_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_speed_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_speed_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_speed_faq4_a", locale)
	if (locale === "en") return en_uc_speed_faq4_a(inputs)
	if (locale === "es") return es_uc_speed_faq4_a(inputs)
	if (locale === "de") return de_uc_speed_faq4_a(inputs)
	if (locale === "nl") return nl_uc_speed_faq4_a(inputs)
	if (locale === "fr") return fr_uc_speed_faq4_a(inputs)
	if (locale === "it") return it_uc_speed_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_speed_faq4_a(inputs)
	if (locale === "pt") return pt_uc_speed_faq4_a(inputs)
	if (locale === "ja") return ja_uc_speed_faq4_a(inputs)
	return zh_uc_speed_faq4_a(inputs)
};